module.exports = __webpack_public_path__ + "media/trucks/large_van-d3265f61.svg";